import { Trans } from 'react-i18next';

export const DEFAULT_STORE_OBJECT = {
  progressing: false,
  success: false,
  error: false,
  data: false,
  message: false,
};

export const DEFAULT_LANGUAGE = 'en';

export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';

export const SECONDARY_DATE_FORMAT = 'MMM DD, YYYY';

export const NVISION_USER_TYPES = {
  VEND: 'VEND',
  CUST: 'CUST',
  CARR: 'CARR',
} as const;

export const USER_TYPES_LABEL = {
  VEND: <Trans i18nKey="translation:default.fields.vendor" />,
  CUST: <Trans i18nKey="translation:default.fields.customer.label" />,
  CARR: <Trans i18nKey="translation:default.fields.carrier" />,
};

export const WEEKS_DAYS = [
  {
    value: 'Sunday',
    label: <Trans i18nKey="translation:default.weekDays.sun" />,
  },
  {
    value: 'Monday',
    label: <Trans i18nKey="translation:default.weekDays.mon" />,
  },
  {
    value: 'Tuesday',
    label: <Trans i18nKey="translation:default.weekDays.tue" />,
  },
  {
    value: 'Wednesday',
    label: <Trans i18nKey="translation:default.weekDays.wed" />,
  },
  {
    value: 'Thursday',
    label: <Trans i18nKey="translation:default.weekDays.thu" />,
  },
  {
    value: 'Friday',
    label: <Trans i18nKey="translation:default.weekDays.fri" />,
  },
  {
    value: 'Saturday',
    label: <Trans i18nKey="translation:default.weekDays.sat" />,
  },
];

export const SORTING_ORDERS = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type SORTING_ORDER = keyof typeof SORTING_ORDERS;

export const MODULES_ID = {
  SHIPMENT: 1,
  VISIBILITY: 7,
};

export const INCLUSIVE_EXCLUSIVE_OPTION = [
  {
    label: 'Inclusive',
    value: 'I',
  },
  {
    label: 'Exclusive',
    value: 'E',
  },
];

export const YES_NO_OPTIONS = [
  { label: <Trans i18nKey="translation:default.options.yes" />, value: 'Y' },
  { label: <Trans i18nKey="translation:default.options.no" />, value: 'N' },
];
export const YES_NO_SELECT_OPTIONS_EMPTY = [
  { label: <Trans i18nKey="translation:default.buttons.select" />, value: '' },
  { label: <Trans i18nKey="translation:default.options.yes" />, value: 'Yes' },
  { label: <Trans i18nKey="translation:default.options.no" />, value: 'No' },
];

export const TRUE_FALSE_SELECT_OPTIONS_EMPTY = [
  { label: <Trans i18nKey="translation:default.buttons.select" />, value: '' },
  { label: <Trans i18nKey="translation:default.options.yes" />, value: true },
  { label: <Trans i18nKey="translation:default.options.no" />, value: false },
];

export const STATUS_OPTIONS = [
  { label: <Trans i18nKey="translation:default.buttons.select" />, value: '' },
  { label: 'Active', value: 'Active' },
  { label: 'InActive', value: 'Inactive' },
];

export const NXP_STATUS_OPTIONS = [
  { label: <Trans i18nKey="translation:default.buttons.select" />, value: '' },
  { label: 'Active', value: 'A' },
  { label: 'InActive', value: 'I' },
];

export const YES_NO_SELECT_OPTIONS = [
  {
    label: <Trans i18nKey="translation:default.buttons.select" />,
    value: '',
  },
  { label: <Trans i18nKey="translation:default.options.yes" />, value: 'Y' },
  { label: <Trans i18nKey="translation:default.options.no" />, value: 'N' },
];

export const PRICING_TYPES_OPTIONS = [
  {
    label: <Trans i18nKey="translation:default.fields.actualCarrierRate" />,
    value: 'PACT',
  },
  {
    label: <Trans i18nKey="translation:default.fields.comparativeRate" />,
    value: 'PINV',
  },
];

export const LINER_CODES_OPTIONS = [
  {
    label: <Trans i18nKey="translation:default.options.cargo" />,
    value: 'CRGO',
  },
  {
    label: <Trans i18nKey="translation:default.options.passenger" />,
    value: 'PAX',
  },
];

export const TMS_SETTINGS_SPOT_BID_OPTIONS = [
  { label: <Trans i18nKey="translation:default.options.new" />, value: 'New' },
  {
    label: <Trans i18nKey="translation:default.options.spotBidEnd" />,
    value: 'SpotBidEnd',
  },
  {
    label: <Trans i18nKey="translation:default.options.spotBid" />,
    value: 'SpotBid',
  },
];

export const TMS_SETTINGS_AUCTION_TYPE_OPTIONS = [
  { label: <Trans i18nKey="translation:default.options.blind" />, value: 'N' },
  {
    label: <Trans i18nKey="translation:default.options.reverseBlind" />,
    value: 'Y',
  },
];

export const TMS_SETTINGS_POV_DESTINATION_OPTIONS = [
  {
    label: <Trans i18nKey="translation:default.options.purchaseOrder" />,
    value: 'PO',
  },
  { label: <Trans i18nKey="translation:default.fields.branch" />, value: 'BR' },
];

export const TMS_SETTINGS_POV_ROUTING_METHOD_OPTIONS = [
  { label: <Trans i18nKey="translation:default.options.na" />, value: 'NA' },
  {
    label: <Trans i18nKey="translation:default.options.routingGuide" />,
    value: 'RG',
  },
  {
    label: <Trans i18nKey="translation:default.buttons.rateShop" />,
    value: 'RS',
  },
];

export const RECALCULATE_TYPE = [
  { label: 'Delivery', value: 'DEL' },
  { label: 'None', value: 'NONE' },
  { label: 'Shipment', value: 'SHI' },
];

export const TMS_SETTINGS_FIELDS = {
  customerKey: null,
  statusInTMS: 'N',
  brokerageCustomer: null,
  nextID: null,
  shipmentApprovalRequired: null,
  enableMasterOrders: null,
  isCategoryToValidate: null,
  pricingType: null,
  isWeightCalculation: null,
  isvisiablePaidBy: null,
  isDefaultRatingPreference: null,
  defaultBranchKey: null,
  defaultIncoTerm: null,
  defaultHazmat: null,
  defaultRatingPreferencevalue: null,
  defaultShipmentTerms: null,
  defaultFreightClass: null,
  defaultProductCode: null,
  defaultProdDesc: null,
  defaultLen: null,
  defaultWidth: null,
  defaultHeight: null,
  showCurrentBid: null,
  defaultSpotBidEndStatus: null,
  adminEmail: null,
  shipmentSupportMail: null,
  emailFrom: null,
  qtyTolerancePercentage: 10,
  autoRate: null,
  autoTender: null,
  autoTenderAmount: null,
  shipmentApprovalCount: null,
  isRequiredApprovalNumber: null,
  isHideShipmentNumber: null,
  defaultEquipmentType: null,
  defaultCargoType: null,
  isReverseAuction: null,
  maxBidHours: null,
  poValidationFlag: null,
  routingMethod: null,
  shipmentIdAlphaPrefix: null,
  povDestinationMethod: null,
  shipmentTermsAllowed: null,
  numberOfRoutingCarrierReturned: null,
  shipmentIdStartingInteger: null,
  defaultUom: null,
  defaultPackageUom: null,
  isEquipment: null,
  isCargo: null,
  defaultPaymentTerms: null,
  defaultShipmentType: null,
  defaultClass: null,
  defaultFobCode: null,
  minimumDays: null,
  minimumDaysErrorMsg: null,
  maximumDays: null,
  maximumDaysErrorMsg: null,
  isDefaultSelected: null,
  recalculateFreightClass: null,
  routingGuideMatch: null,
  allowDraftShipments: null,
  povItemDistribution: null,
  displayPO_SOOnShipmentLevel: null,
  disableExpiredBids: null,
  bidExpiryNoOfDays: null,
  shipmentEmailAttachment: null,
  autoTenderCargoType: null,
  isShowRatingDetails: null,
  defaultBusinessJustification: null,
  createdBy: null,
  createdOn: null,
  modifiedBy: null,
  modifiedOn: null,
};

export const SHIPMENT_TRACK_OPTIONS = {
  CONTAINER_TRACKING: 1,
  TRACKING_NUMBER: 2,
  ITRACK: 3,
};

export const ENABLE_DISABLE_OPTIONS = [
  {
    value: true,
    label: <Trans i18nKey="translation:default.options.enable" />,
  },
  {
    value: false,
    label: <Trans i18nKey="translation:default.options.disable" />,
  },
];

export const REGEX_EMAIL_LIST_BY_COMMA =
  /^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4}[\W]*,{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4})[\W]*$/g;

export const DRAFT_SEARCH_TYPES_OPTION = [
  {
    label: <Trans i18nKey="translation:default.options.draftShipment" />,
    value: 'Draft',
  },
  {
    label: <Trans i18nKey="translation:default.options.finalShipment" />,
    value: 'Final',
  },
  {
    label: <Trans i18nKey="translation:default.options.preBookingShipment" />,
    value: 'Pre-Booking',
  },
];

export const PRE_BOOKING_STATUS_OPTIONS = [
  {
    label: 'Open',
    value: 'O',
  },
  {
    label: 'Expired',
    value: 'E',
  },
];

export const SORTING_FIELDS_SHIPMENT_ORDER = [
  {
    label: <Trans i18nKey="translation:default.fields.shipmentNumber.label" />,
    value: 'shipmentNo',
  },
  {
    label: <Trans i18nKey="translation:default.fields.bolNumber" />,
    value: 'BolNumber',
  },
  {
    label: <Trans i18nKey="translation:default.fields.origin" />,
    value: 'origin',
  },
  {
    label: <Trans i18nKey="translation:default.fields.destination" />,
    value: 'destination',
  },
  {
    label: <Trans i18nKey="translation:default.fields.transportationProvider.label" />,
    value: 'CarrierName',
  },
  {
    label: <Trans i18nKey="translation:default.fields.cargoType.label" />,
    value: 'cargoType',
  },
  {
    label: <Trans i18nKey="translation:default.fields.expectedShipDate.label" />,
    value: 'ExpShipDate',
  },
  {
    label: <Trans i18nKey="translation:default.fields.expectedDeliveryDate" />,
    value: 'ExpDeliveryDate',
  },
  {
    label: <Trans i18nKey="translation:default.fields.weight" />,
    value: 'weight',
  },
  {
    label: <Trans i18nKey="translation:default.fields.cube.label" />,
    value: 'cube',
  },
];

export const RATE_SHOP_TYPES = [
  {
    value: 'C',
    label: <Trans i18nKey="translation:default.options.сurrent" />,
  },
  {
    value: 'H',
    label: <Trans i18nKey="translation:default.options.historical" />,
  },
];

export const THEME_FONT_FAMILY_LIST = [
  { value: "'Open Sans', Helvetica", label: 'Open Sans' },
  { value: 'Helvetica Neue', label: 'Helvetica Neue' },
];

export const ORIGIN_TYPE = [
  { value: 'Zone', label: 'Zone' },
  { value: 'Location', label: 'Location' },
];

export const LANGUAGE_LIST = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
  { value: 'es-es', label: 'Español (España)' },
  { value: 'es-mx', label: 'Español (México)' },
  { value: 'it', label: 'Italiano' },
  { value: 'ch', label: '中文' },
  { value: 'zh-tw', label: '繁體中文' },
  { value: 'fr', label: 'Français' },
  { value: 'nl', label: 'Nederlands' },
  { value: 'pt', label: 'Português' },
  { value: 'pt-br', label: 'Português (Brasileiro)' },
  { value: 'de', label: 'Deutsch' },
  { value: 'pl', label: 'Polski' },
  { value: 'fi', label: 'Suomalainen' },
  { value: 'ko', label: '한국인' },
  { value: 'ja', label: '日本語' },
];

export const DEFAULT_THEME_DATA = {
  muted: '#91959b',
  'muted-rgb-6': 'rgba(145, 149, 155, 0.6)',
  dark: '#131432',
  'dark-1': '#00557d',
  'dark-2': '#3c4b64',
  danger: '#e9523f',
  iconDanger: '#fd0000',
  'danger-1': '#c71b05',
  'danger-2': '#ffd2d2',
  'danger-3': '#d47a11',
  primary: '#252eff',
  info: '#13d4fe',
  warning: '#f7b74b',
  white: '#ffffff',
  light: '#eff3fa',
  success: '#0aa45a',
  iconSuccess: '#2AFF00',
  'success-1': '#c9ffd8',
  grey: '#dce5e9', // Old #fcf9f9
  'grey-1': '#bebebf',
  'grey-2': '#f7f7f7',
  'grey-3': '#f4fdff',
  'grey-4': '#e2e0e2',
  header: '#0070a3',
  black: '#000000',
  highlight: '#000000', // Old #8b0097
  label: '#262626',
  border: '#c5c5c5',
  disabled: '#cfcfcf',
  'disabled-text': '#747474',
  selected: '#f7f7f7',
  'dark-footer-2': '#006697',
  'tab-border': '#f0f0f0',
  fontSizePercent: '-10%',
  inputsHeight: '30px',
  invalidInput: '#c71b05',
  'font-family': "'Open Sans', Helvetica",
  topMenuText: '#ffffff',
  bottomMenuText: '#ffffff',
};

export const SP_CARRIERS_TYPES = {
  FEDEX: 'FEDX',
  DHL: 'DHLC',
  UPS: 'UPSN',
};

export const PARCEL_EXPRESS_WEIGHT_UOM_TYPES = {
  0: 'LB',
  1: 'KG',
};

export const DATE_FORMATS = {
  'MM/DD/YYYY': 'MM/DD/YYYY',
  'DD/MM/YYYY': 'DD/MM/YYYY',
};

export const DATE_FORMAT_OPTIONS = [
  { label: DATE_FORMATS['MM/DD/YYYY'], value: DATE_FORMATS['MM/DD/YYYY'] },
  { label: DATE_FORMATS['DD/MM/YYYY'], value: DATE_FORMATS['DD/MM/YYYY'] },
];

export const USER_PREFERENCES = {
  HEADER_COLOR: 'header',
  TOP_MENU_TEXT_COLOR: 'topMenuTextColor',
  FONT_FAMILY: 'fontFamily',
  BOTTOM_MENU_COLOR: 'bottomMenuColor',
  BOTTOM_MENU_TEXT_COLOR: 'bottomMenuTextColor',
  FONT_SIZE: 'fontSize',
  PREFERRED_LANGUAGE: 'preferedLanguage',
  DEFAULT_DATE_FORMAT: 'defaultDateFormat',
  SHIPMENT_VIEW_TYPE: 'shipmentViewType',
  LD_CLAIM_VIEW_TYPE: 'lossAndDamageViewType',
  OC_CLAIM_VIEW_TYPE: 'overchargeViewType',
  SHIPMENT_PRODUCT_VIEW_TYPE: 'shipmentProductViewType',
};

export const SHIPMENT_NO_HIDE_STATUSES = ['NEW', 'RATED', 'UNAPPROVED', 'PARTIAL', 'SPOT BID', 'SPOTBIDEND'];

export const SHIPMENT_CARRIERS_CHANGE_ELIGIBLE_STATUSES = [
  'NEW',
  'RATED',
  'AUTO-RATED',
  'SPOT BID',
  'SPOTBIDEND',
  'ROUTED',
  'AUTO-ROUTE',
  'RATE ERROR',
];

export const SHIPMENT_RATE_ENTRY_BUTTON_STATUSES = ['New', 'Rated', 'Auto-Rated', 'Auto-Route', 'Rate Error'];

export const SHIPMENT_RATE_ENTRY_BUTTON_REMOVE_STATUSES = ['New', 'Rated', 'Auto-Rated', 'Auto-Route', 'Rate Error'];

export const SHIPMENT_APPROVE_BUTTON_VISIBLE_STATUSES = [
  'Rated',
  'Auto-Rated',
  'Tender',
  'Auto-Tendered',
  'In-Transit',
  'Approved',
  'Unapproved',
];

export const OVERCHARGE_CLAIMS_EXPORT_FIELDS = [
  {
    columnName: 'ClaimNumber',
    label: <Trans i18nKey="translation:default.fields.claimNumber" />,
    value: 'customerClaimNo',
  },
  {
    columnName: 'TransportationProvider',
    label: <Trans i18nKey="translation:default.fields.transportationProvider.label" />,
    value: 'carrierName',
  },
  {
    columnName: 'PackageNumber',
    label: <Trans i18nKey="translation:default.fields.packageNumber" />,
    value: 'packageNumber',
  },
  {
    columnName: 'InvoiceNumber',
    label: <Trans i18nKey="translation:default.fields.invoiceNumber" />,
    value: 'invoiceNumber',
  },
  {
    columnName: 'OverchargeAmount',
    label: <Trans i18nKey="translation:default.fields.overchargeAmount" />,
    value: 'overchargeAmount',
  },
  {
    columnName: 'RecoveryAmount',
    label: <Trans i18nKey="translation:default.fields.recoveryAmount" />,
    value: 'recoveryAmount',
  },
  {
    columnName: 'AuditedBy',
    label: <Trans i18nKey="translation:default.fields.auditedBy" />,
    value: 'auditedBy',
  },
  {
    columnName: 'PreparedBy',
    label: <Trans i18nKey="translation:default.fields.preparedBy" />,
    value: 'preparedBy',
  },
  {
    columnName: 'SubmittedBy',
    label: <Trans i18nKey="translation:default.fields.submittedBy" />,
    value: 'submittedBy',
  },
  {
    columnName: 'SubmittedDate',
    label: <Trans i18nKey="translation:default.fields.submittedDate" />,
    value: 'dateSubmitted',
  },
  {
    columnName: 'AmendmentDate',
    label: <Trans i18nKey="translation:default.fields.amendmentDate" />,
    value: 'ammendmentDate',
  },
  {
    columnName: 'Reason',
    label: <Trans i18nKey="translation:default.fields.reason.label" />,
    value: 'reasonCodeDesc',
  },
  {
    columnName: 'ClaimStatus',
    label: <Trans i18nKey="translation:default.fields.claimStatus" />,
    value: 'claimStatusDescription',
  },
  {
    columnName: 'ClaimType',
    label: <Trans i18nKey="translation:default.fields.claimType" />,
    value: 'claimTypeDesc',
  },
  {
    columnName: 'ClosedDate',
    label: <Trans i18nKey="translation:default.fields.closedDate" />,
    value: 'closedDate',
  },
];

export const PARCEL_EXPRESS_CHART_TYPES = {
  TOTAL_SPEND: 'totalSpend',
  TOTAL_SPEND_BY_CARRIERS: 'totalSpendByCarriers',
  BY_MONTHS: 'byMonths',
};

export const PARCEL_EXPRESS_CHART_TYPES_API = {
  [PARCEL_EXPRESS_CHART_TYPES.TOTAL_SPEND]: 'TotalSpend',
  [PARCEL_EXPRESS_CHART_TYPES.TOTAL_SPEND_BY_CARRIERS]: 'TransportationProvider',
  [PARCEL_EXPRESS_CHART_TYPES.BY_MONTHS]: 'Month',
};

export const SP_CARRIERS_TYPES_TO_LABELS = {
  [SP_CARRIERS_TYPES.FEDEX]: 'FEDEX',
  [SP_CARRIERS_TYPES.DHL]: 'DHL',
  [SP_CARRIERS_TYPES.UPS]: 'UPS',
};

export const SP_CARRIERS_COLORS = {
  [SP_CARRIERS_TYPES.FEDEX]: '#4D148C',
  [SP_CARRIERS_TYPES.UPS]: '#964B00',
  [SP_CARRIERS_TYPES.DHL]: '#FFCC00',
};

export const SEARCH_VIEW_TYPES = {
  CARD: 'CARD',
  TABLE: 'TABLE',
} as const;

export type SearchViewType = (typeof SEARCH_VIEW_TYPES)[keyof typeof SEARCH_VIEW_TYPES];

export const SORTING_FIELDS_ROUTING_GUIDE_ORDER = [
  {
    label: 'Routing Guide Id',
    value: 'RoutingGuideId',
  },
  {
    label: 'Routing Name',
    value: 'RoutingName',
  },
  {
    label: 'Shipment Type',
    value: 'ShipmentType',
  },
  {
    label: 'Branch',
    value: 'BranchDesc',
  },
  {
    label: 'Vendor Name',
    value: 'VendorName',
  },
  {
    label: 'Created By',
    value: 'CreatedByName',
  },
  {
    label: 'Modified By',
    value: 'ModifiedByName',
  },
  {
    label: 'Created On',
    value: 'CreatedOn',
  },
  {
    label: 'Modified On',
    value: 'ModifiedOn',
  },
];

export const NXP_SORTING_FIELDS_ROUTING_GUIDE_ORDER = [
  {
    label: 'Transportation Provider',
    value: 'FirstCarrierName',
  },
  {
    label: 'Transportation Provider Service',
    value: 'FirstCarrierServiceDesc',
  },
  {
    label: 'Client Code',
    value: 'ClientCodeDesc',
  },
  {
    label: 'Account Number',
    value: 'AccountNumber',
  },
  {
    label: 'Comment',
    value: 'Comment',
  },
  {
    label: 'Contact Name',
    value: 'CarrierContactName',
  },
  {
    label: 'Phone Number',
    value: 'CarrierPhoneNumber',
  },
  {
    label: 'Email',
    value: 'CarrierEmail',
  },
  {
    label: 'CCEmail',
    value: 'CarrierCCEmail',
  },
];

export const NXP_SORTING_FIELDS_ROUTING_GUIDE_USER_ORDER = [
  {
    label: 'User Id',
    value: 'UserId',
  },
  {
    label: 'First Name',
    value: 'FirstName',
  },
  {
    label: 'Last Name',
    value: 'LastName',
  },
  {
    label: 'User Name',
    value: 'UserName',
  },
  {
    label: 'Email',
    value: 'Email',
  },
  {
    label: 'Company Name',
    value: 'CompanyName',
  },
  {
    label: 'Client Code',
    value: 'ClientCodeDesc',
  },
  {
    label: 'User Type',
    value: 'UserTypeDesc',
  },
  {
    label: 'Country Name',
    value: 'CountryName',
  },
  {
    label: 'State Name',
    value: 'StateName',
  },
  {
    label: 'City',
    value: 'City',
  },
  {
    label: 'Postal Code',
    value: 'Postal',
  },
  { label: 'Created By Name', value: 'CreatedByName' },
  {
    label: 'Created On',
    value: 'CreatedOn',
  },
];

export const TIME_FORMATION_LIST = [
  { value: '24', label: '24 hrs format' },
  { value: '12', label: '12 hrs format' },
];

export const CLAIMS_SETTINGS_COMPANY_STATUS = [
  { label: 'Active', value: 'Y' },
  { label: 'InActive', value: 'N' },
];

export const HAL_SORTING_FIELDS_ROUTING_GUIDE_ORDER = [
  {
    label: 'Routing Guide Name',
    value: 'RoutingGuideName',
  },
  {
    label: 'Origin Country',
    value: 'OriginCountry',
  },
  {
    label: 'Transportation Group',
    value: 'TransportationGroup',
  },
  {
    label: 'Transportation Mode',
    value: 'TransportationMode',
  },

  {
    label: 'Modified By',
    value: 'ModifiedByName',
  },
  {
    label: 'Modified On',
    value: 'ModifiedOn',
  },
];

export const QUOTE_STATUSES_FOR_CONVERTED_COST_VISIBILITY = ['Ready for Award', 'Awarded', 'Unawarded'];

export const SHIPMENT_RATE_ENTRY_DELETE_BUTTON_VISIBLE_STATUSES = ['New', 'Rated', 'Tender'];

export const HALLIBURTON_GLOBAL_FREIGHT_CUSTOMER_KEY = 6074;

export const FILES_ERROR_CODES = {
  INVALID_FILE_TYPE: 1,
  FILE_TOO_LARGE: 2,
  FILE_TOO_SMALL: 3,
  MAXIMUM_FILE_COUNT_REACHED: 4,
};

export const FIVE_DIGITS_POSITIVE_DECIMALS_PATTERN = /^[0-9]{0,5}(?:\.[0-9]{1,2})?$/;
